var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-app"}},[_c('v-navigation'),_c('v-welcome'),_c('v-features'),_c('v-topics'),_c('v-speakers'),_c('v-agenda'),_c('v-ticketing'),_c('v-hightlight'),_c('v-faq'),_c('v-organizers'),_c('v-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }